import { ClientPortal, ClientPortalUser } from '../../data/types';
import { useAppDispatch } from '../hooks';
import {
    addOrReplaceClientPortalAction,
    addOrReplaceClientPortalUserAction,
    clearClientPortalAction,
    removeClientPortalAction,
    removeClientPortalUserAction,
    setClientPortalsAction,
    setClientPortalUsersAction,
} from '../reducers/clientPortalReducer';

export const useClientPortalActions = () => {
    const dispatch = useAppDispatch();

    const setClientPortals = (portals: ClientPortal[]) => {
        dispatch(setClientPortalsAction(portals));
    };

    const addOrReplaceClientPortal = (portal: ClientPortal) => {
        dispatch(addOrReplaceClientPortalAction(portal));
    };

    const removeClientPortal = (portalId: string) => {
        dispatch(removeClientPortalAction(portalId));
    };

    const setClientPortalUsers = (users: ClientPortalUser[]) => {
        dispatch(setClientPortalUsersAction(users));
    };

    const addOrReplaceClientPortalUser = (user: ClientPortalUser) => {
        dispatch(addOrReplaceClientPortalUserAction(user));
    };

    const removeClientPortalUser = (userId: string) => {
        dispatch(removeClientPortalUserAction(userId));
    };

    const clearClientPortal = () => {
        dispatch(clearClientPortalAction());
    };

    return {
        addOrReplaceClientPortal,
        addOrReplaceClientPortalUser,
        clearClientPortal,
        removeClientPortal,
        removeClientPortalUser,
        setClientPortals,
        setClientPortalUsers,
    };
};
